import React, { useState, useCallback, useRef } from 'react'
import { format, parseISO } from 'date-fns'
import ProjectItemMenu from '@chegg-wt/core/components/ProjectItemMenu'
import VisibleOnHoverWrapper from '@chegg-wt/core/components/VisibleOnHoverWrapper'
import ProjectItemLink from '../ProjectListItemLink'
import * as Styled from './styled'
import { ProjectListItemProps } from './types'

const ProjectListItem: React.FunctionComponent<ProjectListItemProps> = ({
  id,
  index,
  name,
  date,
  createdAt,
  onSelect,
  style,
  onSelectStarred,
  starred,
  selected: isSelected,
  onMove,
  onEdit,
  onDelete,
}) => {
  const [isStarred, setStarred] = useState(starred)

  const starHandler = useCallback(() => {
    setStarred(!isStarred)
    onSelectStarred(id, !isStarred)
  }, [id, isStarred])

  const checkHandler = useCallback(() => {
    onSelect(id, !isSelected)
  }, [id, isSelected])

  const projectItemMenu = useRef<HTMLDivElement>(null)
  const projectDateText = useRef<HTMLElement>(null)

  return (
    <VisibleOnHoverWrapper
      dismissible={projectItemMenu}
      showIfDismissed={projectDateText}
    >
      <Styled.ProjectListItem key={id}>
        <Styled.Controls>
          <Styled.ProjectItemCheck
            aria-labelledby={id}
            aria-label={`select ${name}`}
            data-test={`select-${index}`}
            onChange={checkHandler}
          />
          <Styled.ProjectItemStar
            aria-label={`star ${name}`}
            type="checkbox"
            checked={isStarred}
            onChange={starHandler}
          />
        </Styled.Controls>
        <Styled.Content id={id} data-test={`project-${index}`}>
          <ProjectItemLink id={id} name={name} createdAt={createdAt} style={style} />
          <div ref={projectItemMenu}>
            <ProjectItemMenu
              onMove={onMove}
              onEdit={() => onEdit(name, style, id)}
              onDelete={onDelete}
            />
          </div>
          <Styled.ProjectDateText ref={projectDateText}>
            Updated: {format(parseISO(date), 'MM/dd/yyyy')}
          </Styled.ProjectDateText>
        </Styled.Content>
      </Styled.ProjectListItem>
    </VisibleOnHoverWrapper>
  )
}

export default ProjectListItem
